import { Component } from '@angular/core';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'placeme-home-jumbotron',
  templateUrl: './home-jumbotron.component.html',
  styleUrls: ['./home-jumbotron.component.scss'],
})
export class HomeJumbotronComponent {
  faChevronDown = faChevronDown;

  isFragment(href: string): boolean {
    return href.startsWith('#');
  }
}
